import {
    Active, DragEndEvent, DragOverEvent,
    KeyboardSensor, PointerSensor, useSensor, useSensors,
} from "@dnd-kit/core";

import { sortableKeyboardCoordinates } from "@dnd-kit/sortable";
import { useImmerAtom } from "jotai-immer";
import { useMemo, useState } from "react";
import courseService, { oneCourseatom } from "../CourseService";
import { arrayMoveMutate } from "src/utils/ArrayMethods";

export const useThemeDragNDrop = (courseId: string, allThemesId: string) => {

    const [_, setCourseDataFunction] = useImmerAtom(useMemo(() => oneCourseatom(courseId || ""), [courseId]));
    const [active, setActive] = useState<Active | null>(null);

    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates
        })
    );

    const dragOver = (e: DragOverEvent) => {
        const { active, over } = e;
        if (!over) {
            return;
        }
        if (active.data.current?.sortable.containerId === allThemesId
            && active.data.current?.sortable.index !== undefined
            && over.data.current?.sortable.index !== undefined) {
            setCourseDataFunction(courseData => {
                if (courseData.Course.Themes) {
                    arrayMoveMutate(courseData.Course.Themes, active.data.current!.sortable.index, over.data.current!.sortable.index);
                }
            });
            return;
        }

        if (e.active.data.current?.sortable.containerId !== e.over?.data.current?.sortable.containerId) {

            // part moved to a new theme

            setCourseDataFunction(courseData => {
                if (courseData.Course.Themes) {
                    const ths = courseData.Course.Themes;
                    const newTheme = ths.find(t => t.Id === e.over?.data.current?.sortable.containerId);
                    const oldTheme = ths.find(t => t.Id === e.active?.data.current?.sortable.containerId);
                    const part = oldTheme?.Parts.find(p => p.Id === e.active.id);

                    if (part && oldTheme && newTheme) {
                        oldTheme.Parts = oldTheme.Parts.filter(p => p.Id !== e.active.id);
                        newTheme.Parts.splice(e.over?.data.current?.sortable.index, 0, part);
                    }

                }
            });
        }
        else {  // part moved within theme
            setCourseDataFunction(courseData => {
                if (courseData.Course.Themes) {
                    const ths = courseData.Course.Themes;
                    const theme = ths.find(t => t.Id === e.active?.data.current?.sortable.containerId);
                    const fromIndex = e.active?.data?.current?.sortable?.index;
                    const toIndex = e.over?.data?.current?.sortable?.index;
                    if (theme && fromIndex !== undefined && toIndex !== undefined) {
                        arrayMoveMutate(theme.Parts, fromIndex, toIndex);
                    }
                }
            });
        }    }

    const dragEnd = async (ev: DragEndEvent) => {
        setActive(null);
        try {
            await courseService.saveCourse(courseId!);
        } catch (error) {
            console.error("Failed to save course after drag:", error);
        }
    };

    return { dragEnd, dragOver, sensors, active, setActive };

}